// extracted by mini-css-extract-plugin
export default {"container":"Feed_container__-B+5r","blankFeed":"Feed_blankFeed__LDP3C","loading":"Feed_loading__VMbx3"};